import React from 'react';
import { useStyles } from "./styles/EduContentsControlStyle";
import {Box, Button,  FormControl, Typography, MenuItem, Select} from "@material-ui/core";
import EduContentsControlButton from "./EduContentsControlButton";
import { ReactComponent as ArrowDownIcon } from '../../../../common/images/ArrowDownIcon.svg';
import clsx from "clsx";
import {inject, observer} from "mobx-react";

function EduContentsControl(props) {
    const classes = useStyles();
    const {summaryContentStore} = props;

    const onChangeStep = (e) => {
        const value = Number(e.target.value);
        if (isNaN(value)) return;
        summaryContentStore.setTempSelectedStep(value);
    }
    const onChangeDay = (e) => {
        const value = Number(e.target.value);
        if (isNaN(value)) return;
        summaryContentStore.setTempSelectedDay(value);
    }

    const onClickSearchButton = () => {
        summaryContentStore.setSearchValue();
        summaryContentStore.getSummaryContents();
    }

    return (
        <div className={classes.root}>
            <Box>
                <Box display='flex' alignItems='center'>
                    <Typography className={classes.textStyle}>Step</Typography>
                    <FormControl className={classes.formControl}>
                        <Select
                            value={summaryContentStore.tempSelectedStep}
                            onChange={onChangeStep}
                            IconComponent={(props) => (
                                <Box>
                                    <ArrowDownIcon  {...props} />
                                </Box>
                            )}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "right"
                                },
                                transformOrigin:{
                                    vertical: 'top',
                                    horizontal: 'right',
                                },
                                getContentAnchorEl: null,
                                className:classes.selectPopover
                            }}
                            // onBlur={this.handleDomainBoxFocusOut2}
                        >
                            <MenuItem value={0}>전체</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                            <MenuItem value={4}>4</MenuItem>
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={6}>6</MenuItem>
                            <MenuItem value={7}>7</MenuItem>
                            <MenuItem value={8}>8</MenuItem>
                            <MenuItem value={9}>9</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={11}>11</MenuItem>
                            <MenuItem value={12}>12</MenuItem>
                            <MenuItem value={13}>13</MenuItem>
                            <MenuItem value={14}>14</MenuItem>
                            <MenuItem value={15}>15</MenuItem>
                            <MenuItem value={16}>16</MenuItem>
                            <MenuItem value={17}>17</MenuItem>
                            <MenuItem value={18}>18</MenuItem>
                            <MenuItem value={19}>19</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={21}>21</MenuItem>
                        </Select>
                    </FormControl>
                    <Typography className={clsx(classes.textStyle, classes.marginLeft30)}>Day</Typography>
                    <FormControl className={classes.formControl}>
                        <Select
                            value={summaryContentStore.tempSelectedDay}
                            onChange={onChangeDay}
                            IconComponent={(props) => (
                                <Box>
                                    <ArrowDownIcon  {...props} />
                                </Box>
                            )}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "right"
                                },
                                transformOrigin:{
                                    vertical: 'top',
                                    horizontal: 'right',
                                },
                                getContentAnchorEl: null,
                                className:classes.selectPopover
                            }}
                            // onBlur={this.handleDomainBoxFocusOut2}
                        >
                            <MenuItem value={0}>전체</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                            <MenuItem value={4}>4</MenuItem>
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={6}>6</MenuItem>
                            <MenuItem value={7}>7</MenuItem>
                            <MenuItem value={8}>8</MenuItem>
                            <MenuItem value={9}>9</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={11}>11</MenuItem>
                            <MenuItem value={12}>12</MenuItem>
                            <MenuItem value={13}>13</MenuItem>
                            <MenuItem value={14}>14</MenuItem>
                            <MenuItem value={15}>15</MenuItem>
                            <MenuItem value={16}>16</MenuItem>
                            <MenuItem value={17}>17</MenuItem>
                            <MenuItem value={18}>18</MenuItem>
                            <MenuItem value={19}>19</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            {/*<MenuItem value={21}>21</MenuItem>*/}
                        </Select>
                    </FormControl>

                    <Button className={clsx(classes.buttonStyle, classes.buttonStyle3)}  disableRipple onClick={onClickSearchButton}>
                        <Typography>검색</Typography>
                    </Button>
                </Box>
            </Box>
            <EduContentsControlButton />
        </div>
    );
}

export default
inject('summaryContentStore')(
    observer(EduContentsControl)
);
